import useSWR from 'swr';
import useSWRCacheKeys from '../../hooks/useSWRCacheKeys';
import { Tab, TicketTab, customSWRConfig } from '../../model/types';
import { fetcherWithToken } from '../../utils/fetchers';

/**
 * This function retrieves information about a list of open tabs using a provided set of keys.
 * @param {string} openTabKeys - i.e, TICKET-1,TICKET-6,USER-3,PLUGIN-2,DEAL-1,ORGANIZATION-3
 * @ {string} openTabKeys - i.e, TICKET-TICKET-1,TICKET-TICKET-6,USER-3,PLUGIN-2,DEAL-1,ORGANIZATION-3
 */
async function getTabListInfo(openTabKeys: string): Promise<Tab[]> {
    const tabListForRequest = openTabKeys.split(',').map((key) => (key.startsWith('TICKET') ? `TICKET-${key}` : key));

    return await fetcherWithToken(`/tab?tabKeys=${tabListForRequest}`);
}

const useTicketTabListInfo = (openTabKeys: string[], config: customSWRConfig = {}) => {
    const tabListForRequest = openTabKeys?.map((key) => (key.startsWith('TICKET') ? `TICKET-${key}` : key))?.join(',');
    const keys = useSWRCacheKeys(
        !!tabListForRequest && tabListForRequest !== '' ? `/tab?tabKeys=${tabListForRequest}` : null
    );
    return useSWR<TicketTab[]>(keys, { ...config });
};

export { getTabListInfo, useTicketTabListInfo };
